import React from "react";
import { withRouter } from "react-router-dom";
import Main from "./main";
import { ShopperStore } from "./contexts";

function Context() {
  return (
    <ShopperStore>
      <Main />
    </ShopperStore>
  );
}

export default withRouter(Context);
